export class Loading<T> {
  promise: Promise<T>
  done = (_val: T) => {}
  hasSettled = false
  constructor() {
    this.promise = new Promise((resolve) => {
      this.done = resolve
    })
    this.promise.then(() => {
      this.hasSettled = true
    })
  }
}

export let initialRevealingRef = {
  current: new Loading<void>(),
}
